import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { formatResultsFileStatusLabel } from '@/features/uploads/formatters';
import { getChartTitle } from '@/shared/copy/charts';
import { getDetailLabel } from '@/shared/copy/details';
import type { ResultsFileStatus } from '@flowqa/shared';

export type ResultsFilesSortKey = 'fileName' | 'status' | 'createdAt' | 'uploadId';

const resultsFileStatuses: ResultsFileStatus[] = ['queued', 'processing', 'completed', 'failed'];

export const resultsFilesTableDefinition: TableDefinition<ResultsFilesSortKey, ResultsFileStatus> =
  createTableDefinition({
    title: 'Results Files',
    searchAriaLabel: 'Search results files by file name',
    columns: [
      { field: 'fileName', label: 'File', mandatory: true, defaultVisible: true },
      { field: 'executionRunPassed', label: 'Execution Runs', defaultVisible: true },
      { field: 'suiteRunPassed', label: getDetailLabel('suites'), defaultVisible: true },
      { field: 'testRunPassed', label: getDetailLabel('tests'), defaultVisible: true },
      { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
    ],
    defaultSortKey: 'createdAt',
    defaultSortDirection: 'desc',
    sortOptions: [
      { key: 'createdAt', label: getDetailLabel('uploaded') },
      { key: 'fileName', label: 'File' },
      { key: 'status', label: getChartTitle('status') },
      { key: 'uploadId', label: 'Upload' },
    ],
    sortFieldMap: {
      fileName: 'fileName',
      status: 'status',
      createdAt: 'createdAt',
      uploadId: 'uploadId',
    },
    statusOptions: resultsFileStatuses.map((status) => ({
      value: status,
      label: formatResultsFileStatusLabel(status),
    })),
    statusFilterLabel: getChartTitle('status'),
  });
